import { Tooltip } from "@mui/material";
import { TooltipProps } from "@mui/material/Tooltip/Tooltip";

type WithTooltipProps = TooltipProps & {
	textDecoration?: "underline" | "none";
}

const WithTooltip = ({ children, title, textDecoration, onClick, ...props }: WithTooltipProps) => {
	return (
		<span>
			<Tooltip {...props} title={title} slotProps={{ tooltip: { sx: { whiteSpace: "pre-wrap" } } }}>
				<span
					style={{
						cursor: title ? "default" : "initial",
						textDecoration: textDecoration != null ? textDecoration : title ? "underline" : "none",
						textDecorationStyle: "dotted",
						textDecorationColor: "gray",
						display: "flex",
						flexGrow: 1,
					}}
					onClick={onClick}
				>
					{children}
				</span>
			</Tooltip>
		</span>
	);
};

export default WithTooltip;
